export default __webpack_public_path__ + "static/media/4c240fc3962b5184a3bc6287efc51ed5.6d1aa52b.svg";